import axios from "axios"
const API_BASE = '__VUE_APP_API_CMS_URL__';

const instance = axios.create({
    baseURL: API_BASE,
    // baseURL: process.env.VUE_APP_API_CMS_URL,
})

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.method = "post";
export default instance